import { Alert, Box, Grid } from '@mui/material';
import DateChip from 'src/components/DateChip';
import { DebenturesResumeData } from 'src/types/operations/debentures';

import OperationDebenturesResumeCharacteristics from './OperationDebenturesResumeCharacteristics';
import OperationDebenturesResumeGeneralData from './OperationDebenturesResumeGeneralData';
import OperationDebenturesResumeServiceProvider from './OperationDebenturesResumeServiceProvider';
import OperationDebenturesResumeTitles from './OperationDebenturesResumeTitles';

interface OperationDebenturesResumeProps {
  data?: DebenturesResumeData;
  isLoading?: boolean;
  error?: Error;
}

export default function OperationDebenturesResume({
  data,
  isLoading = false,
  error,
}: OperationDebenturesResumeProps) {
  return (
    <Box p={1}>
      {!data && error && (
        <Box px={1} pb={1}>
          <Alert severity="warning" sx={{ fontWeight: 'bold' }}>
            Não foi possível carregar os dados de Debêntures: {error.message}.
            Exibindo layout com placeholders enquanto o endpoint não está
            disponível.
          </Alert>
        </Box>
      )}
      <Box px={1} display="flex" justifyContent="flex-end" alignItems="center">
        <DateChip
          title="Competência"
          date={
            data?.general?.dataCompetencia &&
            /^\d{2}\/\d{4}$/.test(data.general.dataCompetencia)
              ? data.general.dataCompetencia
              : 'N/D'
          }
        />
      </Box>
      <Grid container>
        <Grid item xs={12} md={6}>
          <OperationDebenturesResumeGeneralData data={data?.general} />
        </Grid>
        <Grid item xs={12} md>
          <OperationDebenturesResumeServiceProvider
            data={data?.serviceProviders}
          />
        </Grid>
        <Grid item xs={12}>
          <OperationDebenturesResumeCharacteristics
            data={data?.characteristics}
            isLoading={isLoading}
          />
        </Grid>
        <Grid item xs={12}>
          <OperationDebenturesResumeTitles titles={data?.titles} />
        </Grid>
      </Grid>
    </Box>
  );
}
